const EntryService = require('../services/EntryService').default;
const getSpace = require('./contentful/get-space');
const entryUpdate = require('./contentful/entry-update');
const entryCreate = require('./contentful/entry-create');
const transformer = require('./transformers/warranty');
const linkResolve = require('./contentful/link-resolve');
const processError = require('./contentful/error-process');
const block = require('./block');
const update = require('immutability-helper');

let entryService = null;

const gettingEntryService = () => {
  if (!entryService) {
    entryService = getSpace().then((space) => {
      return new EntryService(space, transformer);
    });
  }

  return entryService;
};

// Include this in case we need to be able to create new ones from admin in the future
const createWarranty = (space, warranty, depth) => {
  return block.saveBlockArray([], warranty.bodytext, false).then((bodyText) => {
    const newWarranty = update(warranty, {
      bodytext: {
        $set: bodyText
      }
    });
    const data = transformer.internalToContentful(newWarranty);

    return entryCreate(space, 'warranty', data);
  }).then((entry) => {
    const data = entry.toPlainObject();
    return linkResolve(space, data, depth);
  }).then((data) => {
    return transformer.contentfulToInternal(data);
  });
};

const updateWarranty = (space, warranty, depth) => {
  return space.getEntry(warranty.id).catch(
    processError
  ).then((entry) => {
    const data = entry.toPlainObject();
    let currentBodytextLinks = [];

    if (data.fields.bodytext && data.fields.bodytext['nb-NO']) {
      currentBodytextLinks = data.fields.bodytext['nb-NO'];
    }

    return block.saveBlockArray(currentBodytextLinks, warranty.bodytext, false).then((newBodyText) => {
      const newWarranty = update(warranty, {
        bodytext: {
          $set: newBodyText
        }
      });
      const data = transformer.internalToContentful(newWarranty);

      return entryUpdate(entry, data);
    }).then((entry) => {
      const data = entry.toPlainObject();
      return linkResolve(space, data, depth);
    }).then((data) => {
      return transformer.contentfulToInternal(data);
    });
  });
};

module.exports = {
  getById(...parameters) {
    return gettingEntryService().then((service) => service.getById(...parameters));
  },

  publish(...parameters) {
    return gettingEntryService().then((service) => service.publish(...parameters));
  },

  publishWithBlocks(warranty, depth) {
    const bodytextIdsToPublish = warranty.bodytext.reduce((ids, md) => {
      if (!md.published || md.updated) {
        ids.push(md.id);
      }

      return ids;
    }, []);

    if (!bodytextIdsToPublish.length) {
      return gettingEntryService().then((service) => service.publish(warranty.id, depth));
    }

    return block.publishBlocks(bodytextIdsToPublish).then(() => {
      return gettingEntryService().then((service) => service.publish(warranty.id, depth));
    });
  },

  unpublish(...parameters) {
    return gettingEntryService().then((service) => service.unpublish(...parameters));
  },

  /* save(...parameters) {
    return gettingEntryService().then((service) => service.save(...parameters));
  }, */
  save(warranty, depth = 0) {
    return getSpace().then((space) => {
      if (warranty.id) {
        return updateWarranty(space, warranty, depth);
      }

      return createWarranty(space, warranty, depth);
    });
  },

  getByMake(makeId, depth = 0) {
    return getSpace().then((space) => {
      return space.getEntries({
        'content_type': 'warranty', // eslint-disable-line
        'fields.make.sys.id': makeId
      }).catch(
        processError
      ).then((entries) => {
        return linkResolve(space, entries, depth).then((entries) => {
          return entries.items.map(transformer.contentfulToInternal);
        });
      });
    });
  }
};
